export const FETCH_CLIENT_LIST_PENDING = 'FETCH_CLIENT_LIST_PENDING';
export const FETCH_CLIENT_LIST_SUCCEEDED = 'FETCH_CLIENT_LIST_SUCCEEDED';
export const FETCH_CLIENT_LIST_FAILED = 'FETCH_CLIENT_LIST_FAILED';
